import { QuickButtonTypes } from '../../../../../../../../store/types';
import './styles.scss';
import React from 'react';

type Props = {
  button: QuickButtonTypes;
  onQuickButtonClicked: (event: any, value: string | number) => any;
}

function QuickButton({ button, onQuickButtonClicked }: Props) {
  const onClick = (event: any) => onQuickButtonClicked(event, button.value);
  if (button.sublabel) {
    return (
      <button className="quick-button quick-button--row" onClick={onClick}>
        <span className="quick-button__label">{button.label}</span>
        <span className="quick-button__sublabel">{button.sublabel}</span>
      </button>
    );
  }
  return (
    <button className="quick-button" onClick={onClick}>
      {button.label}
    </button>
  );
}

export default QuickButton;
